/* eslint-disable react/display-name */
import { memo } from 'react';

import { lazyLoad } from 'utils/loadable';

import { ReportsRouting } from './reports.routing';
export const ReportsComponent = memo(() => {
  return (
    <>
      <ReportsRouting />
    </>
  );
});

export const ReportsModule = lazyLoad(
  () => import('./reports.module'),
  (module) => module.ReportsComponent
);
